import { Grid, styled } from "@mui/material";

export const StyledCard = {
  Dashboard: styled("div")(({ theme }) => ({
    height: "260px",
    margin: "20px",
    marginTop: "10px",
  })),
  LoadingContainer: styled("div")(({ theme }) => ({
    padding: "1px",
    marginTop: "2px",
  })),
  CardContainer: styled(Grid)(({ theme }) => ({
    flex: 1,
    display: "flex",
    maxWidth: "500px",
  })),
  IconRefreshContainer: styled("div", {
    shouldForwardProp: (prop) => prop !== "didInvalidate",
  })(({ theme, didInvalidate }) => ({
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: !didInvalidate ? "flex-end" : "space-between",
    marginTop: "8px",
    marginRight: "8px",
  })),
  CardTextContainer: styled("div")(({ theme }) => ({
    display: "flex",
    margin: "15px 24px 24px 24px",
    padding: "3px",
    color: "gray",
    fontFamily: "Roboto, sans-serif",
    fontSize: "10px",
    fontWeight: "bold",
    borderBottom: "1px gray solid",
  })),
  ErrorDiv: styled("div")(({ theme }) => ({
    height: "14px",
    width: "14px",
    backgroundColor: "red",
    borderRadius: "50px",
    border: "2px solid #f1f1f1",
    marginLeft: "15px",
  })),
};
